module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTDAwMDIyMjAwMDMzMzIyMjIyMjMzMzMzM3+6fAoAAAAIdFJOUwBAwCmk2GBQYdCkkAAAAFdJREFUKM9jYKARMFICAnUkAYkOIGhFF+hIQBJoBBIaIEEFJAEJdAEWoMEoAiBAVQGQjS3oAh0GSAKtIDc4CgqimOGB7lILdAFmQSAwQLMWxfvUFqAUAAAP9CkL6xJNOwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/goalseetingworksheet.png
// module id = 96
// module chunks = 0